import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface InvoiceParams {
  offset: number;
  limit: number;
}

interface UserInvoice {
  externalConversationID: number;
  invoiceID: number;
  invoiceNumber: string;
  invoiceURL: string;
  type: number;
  date: {
    day: number;
    month: number;
    year: number;
  };
  totalAmount: {
    cents: number;
    currencyCode: string;
  };
}

interface UserInvoices {
  invoices: UserInvoice[];
  totalAmount: number;
}

export default (makeCall: MakeCall) => (userId: number, query: InvoiceParams) =>
    makeCall<UserInvoices>('GET', `/api/v2/user/${userId}/invoices`, {
      query,
    });
